import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=482adb6e&scoped=true"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=482adb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482adb6e",
  null
  
)

export default component.exports